(() => {
  const normalizeContactLinks = () => {
    document.querySelectorAll('a[href="#contact"], a[href="/#contact"]').forEach((link) => {
      const label = (link.textContent || '').trim().toLowerCase();
      if (label === 'contact' || label.includes('contact')) link.setAttribute('href', '/pages/contact');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeContactLinks);
  else normalizeContactLinks();
  document.addEventListener('shopify:section:load', normalizeContactLinks);
})();
